var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhotoGallery = function SvgPhotoGallery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.778 20H2.222A2.222 2.222 0 0 1 0 17.778V2.222C0 .995.995 0 2.222 0h15.556C19.005 0 20 .995 20 2.222v15.556A2.222 2.222 0 0 1 17.778 20ZM2.222 2.222v15.556h15.556V2.222H2.222Zm14.445 13.334H3.333l3.334-4.445 1.11 1.111 3.334-4.444 5.556 7.778ZM6.11 8.889a1.667 1.667 0 1 1 0-3.333 1.667 1.667 0 0 1 0 3.333Z",
    fill: "#CCC"
  })));
};
export default SvgPhotoGallery;